import { Link } from 'react-router-dom';
import React, {useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PrimaryButton from '../../components/button/primary';
import CardNormal from '../../components/cards/cardNormal';
import Input from '../../components/input/input';
import Colors from '../../utils/theme/colors';
import AuthSidebar from './components/sidebar';
import useApi from '../../utils/helper/api';
import useValidation from '../../utils/helper/validate';
import useAlert from '../../utils/helper/toast'; 


function EmailVerificationView(){
let [busy, setBusy] = useState(false);
let [otp, setOtp] = useState({});

let api = useApi();
let validate = useValidation();
let alert = useAlert();
let navigate = useNavigate()
let location = useLocation(); console.log(location)


async function verify(){
   let err=false;
   if(!otp.v || otp.v.length < 6  ){
      otp.e=true; otp.m="Provide a valid OTP "; setOtp(JSON.parse(JSON.stringify(otp))); err=true;
   }
   else{ otp.e=false; setOtp(JSON.parse(JSON.stringify(otp))); }
    
   if(err){return; }
   let p = {otp:otp.v, uid:location?.state?.id, email:location?.state?.email }
   setBusy(true)
   let result = await api.post('auth/validate-email', p); //console.log(result);
   setBusy(false)
   if(result.status=="ok"){
      alert.toast(result.message, 'success')
      navigate("/")
   }
   else { alert.toast(result.message, 'error') }
}

return(
   <div className='row no-margin'>

      <div className='col-md-6' style={{width:"100%", minHeight:"100vh", display:'flex', justifyContent:'center', alignItems:"center"}}>
         <div className='col-md-10 no-padding'>
            <CardNormal styles={{border:"none", boxShadow:"none", backgroundColor:"none"}}>
               <div align="center" style={{margin:"15px 0px", padding:"0px 10px"}}>
                  <div className='bold h2' style={{color:Colors.primary}}><b>Verify Email</b> </div>
                  <div className='regular h5' style={{color:Colors.gray}}>We sent an OTP to your email at mail@example.com. Enter the OTP below to complete signup</div>

                  <div style={{marginTop:"35px"}} align="left">
                     <Input
                        placeholder={"Enter OTP"} label="OTP" bg={Colors.bgShade1} type="number"
                        value={otp.v} callback={(v)=>{otp.v=v; setOtp(JSON.parse(JSON.stringify(otp)))}}
                        hasError={otp.e} errorMessage={otp.m}
                      />
                  </div>
                   
                  <div style={{margin:"15px 0px", marginTop:"30px"}} align="left">
                     <PrimaryButton
                        label={"  Submit  "} busy={busy} callback={verify}
                      />
                  </div>
                  <div align="center" style={{margin:"15px 0px", display:"none", marginTop:"20px"}}>
                     <div className='bold h6'>Login instead</div>
                     <Link to={"/"}>
                        <div className='h6' style={{color:Colors.primary, cursor:"pointer", marginTop:"5px"}}>Login here</div>
                     </Link>
                  </div>
               </div>
            </CardNormal>
         </div>
      </div>


      <div className='col-md-6 no-padding'>
         <AuthSidebar />
      </div>
   </div>
)
}
export default EmailVerificationView;